export const SIZES = {
  xs: {
    height: '30px',
    padding: '0 14px',
  },
  'compact-xs': {
    height: 22,
    padding: '0 7px',
  },
  sm: {
    height: '36px',
    padding: '0 18px',
  },
  'compact-sm': {
    height: 26,
    padding: '0 8px',
  },
  md: {
    height: '42px',
    padding: '0 22px',
  },
  'compact-md': {
    height: 30,
    padding: '0 10px',
  },
  lg: {
    height: '50px',
    padding: '0 26px',
  },
  'compact-lg': {
    height: 34,
    padding: '0 12px',
  },
  xl: {
    height: '60px',
    padding: '0 32px',
  },
  'compact-xl': {
    height: 40,
    padding: '0 14px',
  },
};

export const SIZES_WITH_ICON = {
  xs: {
    height: '30px',
    padding: '0 14px',
  },
  'compact-xs': {
    height: 22,
    padding: '0 7px',
  },
  sm: {
    height: '36px',
    padding: '0 40px',
  },
  'compact-sm': {
    height: 26,
    padding: '0 8px',
  },
  md: {
    height: '40px',
    padding: '0 42px',
  },
  'compact-md': {
    height: 30,
    padding: '0 10px',
  },
  lg: {
    height: '50px',
    padding: '0 42px',
  },
  'compact-lg': {
    height: 34,
    padding: '0 12px',
  },
  xl: {
    height: '60px',
    padding: '0 42px',
  },
  'compact-xl': {
    height: 40,
    padding: '0 14px',
  },
};

export type SizeTypes =
  | 'xs'
  | 'sm'
  | 'md'
  | 'lg'
  | 'xl'
  | 'compact-xs'
  | 'compact-sm'
  | 'compact-md'
  | 'compact-lg'
  | 'compact-xl';

export const getSizeStyles = (size: SizeTypes, withIcon = false) => {
  return withIcon ? SIZES_WITH_ICON[size] : SIZES[size];
};
